import React, { Suspense } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import LoaderCircle from "../components/common/loader-circle";
import AdminLayout from "./../components/admin/layout";
import EnterpriseLayout from "./../components/enterprise/layout";
import jwt_decode from "jwt-decode";
import { authRefreshToken } from "./../components/admin/adminServices";
import { enterpriseAuthRefreshTokenRequest } from "./../components/enterprise/enterpriseServices";
import { adminauthLogin, adminAuthRefreshToken, authLogin, enterpriseAuthRefreshToken } from "./../store/reducers/auth";

const checkTokenAndRefresh = async (dispatch, isAdminRefreshDone) => {
  let token = localStorage.getItem("admin_access_token");
  if (!!token) {
    let decoded = jwt_decode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const timeLapsed = decoded.exp - currentTime;
    if (timeLapsed > 0 && timeLapsed <= 14400) {
      // that means token time is less than refresh it
      if (!isAdminRefreshDone) {
        dispatch(adminAuthRefreshToken());
        try {
          const { data: res } = await authRefreshToken();
          if (res.success == true) {
            // notifySuccess(res.message);
            dispatch(adminauthLogin(res.response.accesstoken));
          }
        } catch (err) {
          console.log(err);
        }
        dispatch(adminAuthRefreshToken());
      }
    }
  }
};

const checkEnterpriseTokenAndRefresh = async (dispatch, isEnterpriseRefreshDone) => {
  let token = localStorage.getItem("access_token");
  if (!!token) {
    let decoded = jwt_decode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const timeLapsed = decoded.exp - currentTime;
    if (timeLapsed > 0 && timeLapsed <= 14400) {
      // that means token time is less than refresh it
      if (!isEnterpriseRefreshDone) {
        dispatch(enterpriseAuthRefreshToken());
        try {
          const { data: res } = await enterpriseAuthRefreshTokenRequest();
          if (res.success == true) {
            // notifySuccess(res.message);
            dispatch(authLogin(res.response.accesstoken));
          }
        } catch (err) {
          console.log(err);
        }
        dispatch(enterpriseAuthRefreshToken());
      }
    }
  }
};

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  isMFAAuthenticated,
  isAdminAuthenticated,
  isEnterpriseRefreshDone,
  isMFAAdminAuthenticated,
  isAdminRefreshDone,
  userPermissions,
  userRoleName,
  refreshing,
  routefor,
  layout,
  dispatch,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (routefor == "admin") {
          if (!isAdminAuthenticated) {
            return (
              <Redirect
                to={{
                  pathname: "/admin/login",
                  state: { from: props.location },
                }}
              />
            );
          }
          if (isAdminAuthenticated && !isMFAAdminAuthenticated) {
            return (
              <Redirect
                to={{
                  pathname: "/admin/auth-check",
                  state: { from: props.location },
                }}
              />
            );
          }
          // check if token is expired or not
          checkTokenAndRefresh(dispatch, isAdminRefreshDone);
          return (
            <Suspense fallback={<div>Loading...</div>}>
              <LoaderCircle isLoading={refreshing} />
              {isAdminAuthenticated ? (
                layout == "sidebar" ? (
                  <React.Fragment>
                    <AdminLayout>
                      <Component {...props} />
                    </AdminLayout>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Component {...props} />
                  </React.Fragment>
                )
              ) : (
                <Redirect
                  to={{
                    pathname: "/admin/login",
                    state: { from: props.location },
                  }}
                />
              )}
            </Suspense>
          );
        }
        const restProp = { ...rest };
        const isAdminSchedulerAccess =
          restProp.permission === "ai-task-scheduler" &&
          String(userRoleName || "").toLowerCase() === "admin";
        const isMissingSchedulerPermission =
          restProp.permission === "ai-task-scheduler" &&
          !isAdminSchedulerAccess &&
          !(userPermissions || []).includes("ai-task-scheduler");
        const isMissingExistingPermission =
          restProp.permission !== "ai-task-scheduler" &&
          !_.isEmpty(userPermissions) &&
          !userPermissions.includes(restProp.permission);
        if (
          isAuthenticated &&
          isMFAAuthenticated &&
          restProp.permission !== undefined &&
          (isMissingSchedulerPermission || isMissingExistingPermission)
        ) {
          return (
            <Redirect
              to={{
                pathname: "/enterprise/unauthorized",
                state: { from: props.location },
              }}
            />
          );
        }
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }
        if (isAuthenticated && !isMFAAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/auth-check",
                state: { from: props.location },
              }}
            />
          );
        }
        // check if token is expired or not
        checkEnterpriseTokenAndRefresh(dispatch, isEnterpriseRefreshDone);
        return (
          <Suspense fallback={<div>Loading...</div>}>
            <LoaderCircle isLoading={refreshing} />
            {isAuthenticated && isMFAAuthenticated ? (
              layout == "sidebar" ? (
                <React.Fragment>
                  <EnterpriseLayout>
                    <Component {...props} />
                  </EnterpriseLayout>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Component {...props} />
                </React.Fragment>
              )
            ) : (
              <></>
            )}
          </Suspense>
        );
      }}
    />
  );
};

PrivateRoute.displayName = "Private Routes";

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  location: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  isAdminAuthenticated: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    isEnterpriseRefreshDone: store.auth.isEnterpriseRefreshDone,
    isMFAAuthenticated: store.auth.isMFAAuthenticated,
    isAdminAuthenticated: store.auth.isAdminAuthenticated,
    isMFAAdminAuthenticated: store.auth.isMFAAdminAuthenticated,
    isAdminRefreshDone: store.auth.isAdminRefreshDone,
    refreshing: store.generalActions.refreshing,
    userPermissions: store.auth.user.roleId.permissions,
    userRoleName: store.auth.user.roleId.name,
  };
}

export default withRouter(connect(mapStateToProps)(PrivateRoute));
